<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Guest Checkin
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          
          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="pb-0">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="pb-0">
                          <ValidationProvider 
                            name="Room" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Room
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : A01"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="room"
                              item-text="number"
                              item-value="id"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.id = ''"
                              
                              v-model="form.id"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template 
                                slot="selection" 
                                slot-scope="data">
                                <div
                                  class="body-1">
                                  {{ data.item.number }} - Floor {{data.item.floor}}
                                </div>
                              </template>

                              <template 
                                slot="item" 
                                slot-scope="data">
                                <div
                                  class="body-1">
                                  {{ data.item.number }}- Floor {{data.item.floor}}
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="pb-0">
                          <ValidationProvider 
                            name="Guest Name" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Guest Name
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : John Doe"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.guest_name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="pb-0">
                          <ValidationProvider 
                            name="Phone Number" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Phone Number
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Ex : 081332XXXXXX"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.guest_phone_number"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="pt-0">
                          <div>
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Check In
                            </div>

                            <v-menu
                              ref="datestart"
                              min-width="290px"
                              max-width="290px"
                              transition="scale-transition"
                              offset-y
                              :nudge-right="40"
                              :close-on-content-click="false"
                              v-model="picker.start">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Check In" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    v-on="on"
                                    v-bind="attrs"
                                    
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : 2023-10-10"
                                    :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                    clearable
                                    @click:clear="form.start_date = ''; form.end_date = '';"

                                    v-model="form.start_date"
                                    :success="valid"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-date-picker 
                                :color="set_color"
                                v-model="form.start_date"
                                @input="picker.start = false; form.end_date = '';">
                              </v-date-picker>
                            </v-menu>
                          </div>

                          <div>
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Check Out
                            </div>

                            <v-menu
                              ref="dateend"
                              min-width="290px"
                              max-width="290px"
                              transition="scale-transition"
                              offset-y
                              :nudge-right="40"
                              :close-on-content-click="false"
                              v-model="picker.end">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Check Out" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    v-on="on"
                                    v-bind="attrs"
                                    
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : 2023-10-13"
                                    :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                    clearable
                                    @click:clear="form.end_date = ''"

                                    v-model="form.end_date"
                                    :success="valid"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-date-picker 
                                :color="set_color"
                                :min="form.start_date"
                                v-model="form.end_date"
                                @input="picker.end = false">
                              </v-date-picker>
                            </v-menu>
                          </div>

                          <!-- <ValidationProvider 
                            name="Total Days" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Total Days
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              disabled
                              readonly

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Ex : 3"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.guest_total_day"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider> -->
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="pt-0">
                          <div>
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Check In Time
                            </div>
                            
                            <v-menu
                              ref="timestart"
                              v-model="time.start"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="form.start_time"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Check In Time" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    v-on="on"
                                    v-bind="attrs"
                                    
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : 09:00"
                                    :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                    clearable
                                    @click:clear="form.start_time = ''; form.end_time = '';"

                                    v-model="form.start_time"
                                    :success="valid"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-time-picker
                                v-if="time.start"
                                v-model="form.start_time"
                                full-width
                                :color="set_color"
                                format="24hr"
                                @click:minute="$refs.timestart.save(`${form.start_time}:00`); form.end_time = '';">
                              </v-time-picker>
                            </v-menu>
                          </div>

                          <div>
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Check Out Time
                            </div>

                            <v-menu
                              ref="timeend"
                              v-model="time.end"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="form.end_time"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Check Out Time" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    v-on="on"
                                    v-bind="attrs"
                                    
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : 13:00"
                                    :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                    clearable
                                    @click:clear="form.end_time = ''"

                                    v-model="form.end_time"
                                    :success="valid"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-time-picker
                                v-if="time.end"
                                v-model="form.end_time"
                                full-width
                                :color="set_color"
                                format="24hr"
                                @click:minute="$refs.timeend.save(`${form.end_time}:00`)">
                              </v-time-picker>
                            </v-menu>
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="pt-0">
                          <v-card
                            flat
                            color="#FFE299"
                            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                            <v-card-text
                              class="d-flex align-center justify-center"
                              style="height: 163px;">
                              <div
                                class="font-weight-bold">
                                <div
                                  class="mb-1">
                                  Total
                                </div>

                                <div>
                                  Day(s)
                                </div>
                              </div>

                              <div
                                class="d-flex align-end justify-center mx-8">
                                <div
                                  class="text-h1 font-weight-bold black--text"
                                  style="opacity: 70%;">
                                  {{ form.guest_total_day }}
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>


                      <v-divider 
                        class="mb-4"
                        style="border-top: 2px dashed #e0e0e0;"/>

                      <v-row>
                        <v-col
                          cols="12"
                          md="2">
                          <div>
                            <div class="body-2 mb-2">
                              Guest Photo
                            </div>

                            <folder v-if="form.guest_image_url === ''"
                              v-model="upload.folder">
                              <div 
                                slot="activator">
                                <v-card 
                                  flat
                                  width="200"
                                  height="200"
                                  class="d-flex align-center justify-center cursor-pointer"
                                  style="border-radius: 10px;
                                        border: 2px solid #EBEBEB; 
                                        border-style: dashed;">
                                  <v-avatar v-if="!process.file"
                                    v-ripple
                                    tile 
                                    width="200"
                                    height="200">
                                    <v-icon
                                      size="50"
                                      color="#B9B9B9">
                                      mdi-cloud-upload-outline
                                    </v-icon>
                                  </v-avatar>

                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-card>
                              </div>
                            </folder>

                            <v-card v-if="form.guest_image_url !== ''"
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center"
                              style="border-radius: 10px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-img 
                                  width="100%"
                                  height="100%"
                                  alt="tvandroid" 
                                  :src="form.guest_image_url"
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar>

                              <v-icon 
                                @click="form.guest_image_url = ''"
                                color="red"
                                class="cursor-pointer"
                                style="position: absolute; top: -10px; right: -10px;">
                                mdi-close-circle
                              </v-icon>
                            </v-card>
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="10">
                          <div
                            class="mb-2">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Custom Welcome Guest
                            </div>

                            <div
                              class="mb-4">
                              Please use the variable <strong style="font-weight: bold !important;">%%guest_name%%</strong> to display the guest name on the TV platform.
                            </div>

                            <quill-editor 
                              ref="myTextEditor"
                              :options="{
                                placeholder: 'Ex : Selamat datang di Visuality - Semoga perjalanan anda berkesan bersama kami - Tetap patuhi protokol kesehatan - Follow IG kami di @Visuality untuk mengetahui promo promo terbaru kami.'
                              }"
                              v-model="form.guest_welcome_text_html">
                            </quill-editor>
                          </div>
                          
                          <!-- <ValidationProvider 
                            name="Custom Welcome Guest" 
                            rules="max:256"
                            v-slot="{ errors, valid }">
                            <div 
                              class="body-2 mb-2"
                              style="opacity: 70%;">
                              Custom Welcome Guest
                            </div>

                            <v-textarea
                              filled
                              rounded
                              dense
                              rows="7"

                              :color="set_color"
                              placeholder="Ex : Selamat datang di Visuality - Semoga perjalanan anda berkesan bersama kami - Tetap patuhi protokol kesehatan - Follow IG kami di @Visuality untuk mengetahui promo promo terbaru kami."
                              :append-icon="valid && form.guest_welcome_text !== '' ? 'mdi-check-circle-outline' : ''"

                              v-model="form.guest_welcome_text"
                              :success="valid && form.guest_welcome_text !== ''"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider> -->
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        room: [],
        
        picker: {
          start: false,
          end: false
        },

        time: {
          start: false,
          end: false
        },

        form: {
          id: '',
          // guest_name: 'John Doe',
          // guest_phone_number: '081332051369',
          guest_name: '',
          guest_phone_number: '',
          guest_checkin_datetime: '',
          guest_checkout_datetime: '',
          guest_total_day: 0,
          guest_image_url: '',
          guest_welcome_text: '',
          guest_welcome_text_html: '',

          start_date: '',
          end_date: '',

          start_time: '',
          end_time: ''
        },

        upload: {
          folder: null
        },

        process: {
          form: false,

          file: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      folder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.guest_image_url = this.upload.folder.file_url
            }
          }
        },
        deep: true
      },

      'form.end_date': function() {
        if (this.form.start_date !== '' && this.form.start_date !== null && this.form.end_date !== '' && this.form.end_date !== null) {
          let date_1 = new Date(this.form.start_date),
              date_2 = new Date(this.form.end_date),
              difference = date_2.getTime() - date_1.getTime(),
              days = Math.ceil(difference / (1000 * 3600 * 24))

          this.form.guest_total_day = days + 1
        } else {
          this.form.guest_total_day = 0
        }
      },

      'form.guest_welcome_text_html': function (val) {
        this.form.guest_welcome_text = val.replace(/<[^>]*>/g, '').replace(/[^\w\s]/gi, '')
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchRoom()
    },
    methods: {
      async fetchRoom () {
        let params = {
          limit: 100000
        }

        await get(`admin/master-room/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.room = res.result.data
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          this.form.guest_checkin_datetime = `${this.form.start_date} ${this.form.start_time}`
          this.form.guest_checkout_datetime = `${this.form.end_date} ${this.form.end_time}`

          // SAVE TO REST API
          await post(`admin/guest-room/checkin`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.$router.push('/guest')
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>